import { Tag } from "@albertine/design-system/components/Tag";
import Background from "../components/Background";
import ContentCenter from "../components/ContentCenter";
import Paragraph from "../components/Paragraph";
import {
    AlbertineI18nProvider,
    type ServiceLanguage,
    useAlbertineTranslation,
} from "../package/albertine-i18n";
import type { Tenant } from "../package/albertine-tenant";
import { TenantProvider, useTenant } from "../package/albertine-tenant/components";
import AlbertineLearnMore from "./AlbertineLearnMore";
import { AlbertineBackgroundImageContainer, Screen } from "./LandingScreen";
import "./NotFoundScreen.css";

function NotFoundContent() {
    const t = useAlbertineTranslation();
    const { tenant } = useTenant();

    const notFoundDetails = (
        <div className="not-found__details">
            <Tag className="not-found__tag">{t("page-not-found__title")}</Tag>
            <Paragraph.XLarge.Bold.Text1>
                {t("page-not-found__heading")}
            </Paragraph.XLarge.Bold.Text1>

            <Paragraph.Large.Reqular.Text1>
                {t("page-not-found__description")}
            </Paragraph.Large.Reqular.Text1>
        </div>
    );
    return (
        <Screen>
            {tenant === "albertine" && (
                <>
                    <AlbertineBackgroundImageContainer>
                        {notFoundDetails}
                    </AlbertineBackgroundImageContainer>
                    <AlbertineLearnMore />
                </>
            )}

            {tenant === "hugoboss" && (
                <Background.BookingBg01 className="not-found__container">
                    <ContentCenter.Large>{notFoundDetails}</ContentCenter.Large>
                </Background.BookingBg01>
            )}
        </Screen>
    );
}

export type NotFoundScreenProps = {
    lang: ServiceLanguage;
    tenant: Tenant;
};

export default function NotFoundScreen(props: NotFoundScreenProps) {
    const { lang, tenant } = props;

    return (
        <AlbertineI18nProvider initialLanguage={lang}>
            <TenantProvider
                value={{
                    tenant,
                    dependencyInjection: undefined,
                }}
            >
                <NotFoundContent />
            </TenantProvider>
        </AlbertineI18nProvider>
    );
}
